/* eslint-disable react/react-in-jsx-scope */
import { cilEnvelopeClosed } from '@coreui/icons';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Loading from 'src/components/UI/Loading';
import { formValidator } from 'src/helpers/formValidator';
import useApi from 'src/hooks/useApi';
import { useShowToast } from 'src/hooks/useShowToast';
import CustomInput from '../InputsComponent/CustomInput';
import Button from '../UI/Button';
import LoadingBtn from '../UI/LoadingBtn';

function EmailForgotPassword(prop) {
  const { setOnTaskName, setToken, email, setEmail } = prop;
  const { data, loading, error, postData } = useApi('/BlazorApi/forgot', 'POST', null, 1000000);
  const showToast = useShowToast();

  // ✅ Local loading state for page load
  const [pageLoading, setPageLoading] = useState(true);

  // ✅ Simulate page load (e.g., initialization delay)
  useEffect(() => {
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 1000); // show loader for 1 second (optional)
    return () => clearTimeout(timer);
  }, []);

  const onSend = async () => {
    const form = document.querySelector('.forgot-password-form');
    formValidator();

    // ✅ Email regex validation before submitting
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?:\.[A-Za-z]{2,})*$/;
    if (!email || !emailRegex.test(email)) {
      showToast('Please enter a valid email address.', 'error');
      return;
    }

    if (form.checkValidity()) {
      const forgotPassword = {
        id: 0,
        dspid: 0,
        userId: '',
        userName: '',
        firstName: '',
        lastName: '',
        email: email,
        primaryContact: '',
        token: '',
        roleId: 0,
        password: '',
        rowVer: 0,
        status: 0,
        createdAt: moment().utc().subtract(1, 'year').format(),
        createdBy: 0,
      };

      const emailRes = await postData(forgotPassword);

      if (emailRes && emailRes?.status === true) {
        setToken(emailRes?.data.token);
        showToast(
          `Token successfully sent to ${email}, please check your email for further instructions.`,
        );
        setOnTaskName('securityCode');
      } else {
        if (emailRes?.message === '' || emailRes?.message?.includes('Transaction failed.')) {
          showToast('Email does not exist or invalid.', 'error');
        } else {
          showToast(emailRes?.message ?? 'Something went wrong.', 'error');
        }
      }
    }
  };

  const handleForotPassword = (event) => {
    setEmail(event.target.value.replace(/\s/g, ''));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  // ✅ Show page loader first
  if (pageLoading) {
    return <Loading />;
  }

  return (
    <form className="needs-validation forgot-password-form" onSubmit={handleSubmit} noValidate>
      <div className="centerimage">
        <img className="forgot-password-img" src="4DSPSLogo.png" alt="logo" />
      </div>
      <div className="text-leftside">
        <h2 className="forgot-password-title text-center">Forgot Password ?</h2>
        <p className="forgot-password-email-title text-start ">
          Forgotten your password? Enter your email address | login name to begin reset process.
          After successful submission of reset request, your account will become dormant until
          security code is applied and password retrieval will automatically activate account.
        </p>
      </div>

      <div className="mt-3">
        <CustomInput
          label="Email"
          value={email}
          autoComplete="off"
          onChange={handleForotPassword}
          icon={cilEnvelopeClosed}
          type="text"
          id="email"
          name="email"
          disabled={loading}
          placeholder="Enter email or user id"
          isRequired={true}
          message="Enter email or user id"
          title="Enter email or user id"
        />
      </div>

      <div className="centerimage mt-2">
        {loading ? (
          <LoadingBtn title="Generating Token..." />
        ) : (
          <Button title="Send" type="submit" onClick={onSend} />
        )}
      </div>
    </form>
  );
}

export default EmailForgotPassword;
